import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import ContactList from '../contact-list/contact-list';
import Addresses from '../address/addresses';
import BankList from '../bank-list/bank-list';
import Customer from '../form/customer';
import AccountAnalysis from '../analysis/account';
import SupplierAnalysis from '../analysis/supplier';
import CustomerAnalysis from '../customer-analysis/customer-analysis';
import TransactionAnalysisForm from "../transaction-analysis/transaction-analysis-form";
import TaxIdForm from "../tax-id/tax-id-form";
import CustomerMisc from "../form/customer-misc";
import { Authorize } from '../../components/authorize';
import { withRouterAndLocation } from '../../common/hocs';

class Client extends Authorize {
    state = {
        clientId: this.props.params.clientId,
        clientType: this.props.params.clientType,
        userMenu: [
            { title: "Customer", url: "customer", active: true, path: `/kycs/${this.props.params.clientId}/${this.props.params.clientType}/customer` },
            { title: "Contacts", url: "contacts", active: false, clientType: "Supplier", path: `/kycs/${this.props.params.clientId}/${this.props.params.clientType}/contacts` },
            { title: "Banks", url: "banks", active: false, clientType: "Supplier", path: `/kycs/${this.props.params.clientId}/${this.props.params.clientType}/banks` },
            { title: "Addresses", url: "addresses", active: false, path: `/kycs/${this.props.params.clientId}/${this.props.params.clientType}/addresses` },
            { title: "Business Entity", url: "businessentity", active: false, clientType: "Supplier", path: `/kycs/${this.props.params.clientId}/${this.props.params.clientType}/businessentity` },
            { title: "Tax Ids", url: "taxids", active: false, path: `/kycs/${this.props.params.clientId}/${this.props.params.clientType}/taxids` },
            { title: "Account Analysis", url: "accountanalysis", active: false, path: `/kycs/${this.props.params.clientId}/${this.props.params.clientType}/accountanalysis` },
            { title: "Transaction Analysis", url: "transactionanalysis", active: false, path: `/kycs/${this.props.params.clientId}/${this.props.params.clientType}/transactionanalysis` },
            { title: "Supplier Analysis", url: "supplieranalysis", active: false, clientType: "Supplier", path: `/kycs/${this.props.params.clientId}/${this.props.params.clientType}/supplieranalysis` },
            { title: "Customer Analysis", url: "analysiscustomer", active: false, clientType: "Customer", path: `/kycs/${this.props.params.clientId}/${this.props.params.clientType}/analysiscustomer` },
            { title: "Customer Miscellaneous ", url: "miscellaneouscustomer", active: false, clientType: "Customer", path: `/kycs/${this.props.params.clientId}/${this.props.params.clientType}/miscellaneouscustomer` },
        ]
    }

    handleActiveTab = () => {
    }
    async componentDidMount() {
        if (this.props.context.state.departments.length === 0) {
            this.props.context.actions.setDepartments();
        }
        if (this.props.context.state.masters.length === 0) {
            await this.props.context.actions.setMasters();
        }
    }
    render() {
      const authorizationResult = super.render();
      if (authorizationResult) {
        return authorizationResult;
      }

        let clientId = this.state.clientId;
        let clientType = this.state.clientType;
        var links = this.state.userMenu.map((m) => {
            const loc = this.props.location.pathname;
            const baseKycPath = `/kycs/${this.state.clientId}/${this.state.clientType}`;
            const isDefaultRouteActive = m.url === 'customer' && loc === baseKycPath;
            const isActive = isDefaultRouteActive || loc === m.path;

            m.active = isActive;
            var activeClass = m.active ? "nav-item active" : "nav-item";
            var activeLink = m.active ? "nav-link active" : "nav-link";

            let showMenu = ((m.clientType && this.state.clientType.indexOf(m.clientType) > -1) || (!m.clientType)) ?
                <li key={m.title} className={activeClass}>
                    <Link to={m.path} state={this.props.location.state} className={activeLink}>{m.title} </Link>
                </li>
                : "";
            return showMenu;
        })
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12 mt-2">
                        <nav>
                            <ul className="nav nav-tabs ml-2 mr-2">
                                {links}
                            </ul>
                        </nav>
                        <div className="tab-content ml-2 mr-2 p-2 tab-content-wrapper">
                            {this.props.context ?
                                <Routes>
                                    <Route path="customer" element={<Customer functionality="Client" context={this.props.context} clientId={clientId} clientType={clientType} />} />
                                    {this.state.clientType === 'Supplier' && (
                                        <>
                                            <Route path="contacts" element={<ContactList functionality="Contacts" context={this.props.context} clientId={clientId} clientType={clientType} />} />
                                            <Route path="banks" element={<BankList functionality="Bank Details" context={this.props.context} clientId={clientId} clientType={clientType} />} />
                                        </>
                                    )}
                                    <Route path="addresses" element={<Addresses functionality="Addresses" tag="" context={this.props.context} clientId={clientId} clientType={clientType} />} />
                                    <Route path="businessentity" element={<div><Addresses functionality="Business Entity" tag="BE" context={this.props.context} clientId={clientId} clientType={clientType} /></div>} />
                                    <Route path="supplieranalysis" element={<SupplierAnalysis functionality="Supplier Analysis" context={this.props.context} clientId={clientId} clientType={clientType} />} />
                                    <Route path="analysiscustomer" element={<CustomerAnalysis functionality="Customer Analysis" context={this.props.context} clientId={clientId} clientType={clientType} />} />
                                    <Route path="taxids" element={<TaxIdForm functionality="Tax Id" context={this.props.context} clientId={clientId} clientType={clientType} />} />
                                    <Route path="accountanalysis" element={<AccountAnalysis functionality="Account Analysis" context={this.props.context} clientId={clientId} clientType={clientType} />} />
                                    <Route path="transactionanalysis" element={<TransactionAnalysisForm functionality="Transaction Analysis" context={this.props.context} clientId={clientId} clientType={clientType} />} />
                                    <Route path="miscellaneouscustomer" element={<CustomerMisc functionality="Customer Miscellaneous" context={this.props.context} clientId={clientId} clientType={clientType} />} />
                                    <Route index element={<Customer functionality="Client" context={this.props.context} clientId={clientId} clientType={clientType} />} />
                                </Routes>
                                : ""
                            }
                        </div>
                    </div>

                </div>
            </React.Fragment>
        )
    }
}

// HOC to inject router params
export default withRouterAndLocation(Client);